
import React from "react";
import { AutomatedMessage } from "./message-utils/types";
import { getSortedMessages } from "./message-utils/helpers";
import MessageItem from "./MessageItem";
import EmptyMessageState from "./message-utils/EmptyMessageState";

interface MessagesListProps {
  messages: AutomatedMessage[];
  onEditMessage: (message: AutomatedMessage) => void;
  onDeleteMessage: (id: string) => void;
  onOpenAnalytics: (message: AutomatedMessage) => void;
  onToggleActive: (id: string) => void;
  isModuleEnabled?: boolean;
}

const MessagesList = ({ 
  messages, 
  onEditMessage, 
  onDeleteMessage, 
  onOpenAnalytics,
  onToggleActive,
  isModuleEnabled = true
}: MessagesListProps) => {
  const sortedMessages = getSortedMessages(messages);

  if (sortedMessages.length === 0) {
    return <EmptyMessageState />;
  }

  return (
    <div className="space-y-4">
      {sortedMessages.map((message) => (
        <MessageItem 
          key={message.id}
          message={message}
          onEdit={onEditMessage}
          onDelete={onDeleteMessage}
          onOpenAnalytics={onOpenAnalytics}
          onToggleActive={onToggleActive}
          isModuleEnabled={isModuleEnabled}
        />
      ))}
    </div>
  );
};

export default MessagesList;
